"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePricingStore = void 0;
/* eslint-disable no-useless-catch */
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const getDefaultState = () => ({
    loading: false,
    pricings: [],
    totalPricings: 0,
    axCategories: [],
    pricingId: null,
    pricingName: '',
    pricingStatus: null,
    pricingTypeOption: null,
    pricingTyreCategoryOption: null,
    pricingPassengerTyreSeasonOption: null,
    pricingTruckTyreTypeOption: null,
    pricingRimCategoryOption: null,
    pricingTubesAndTapesCategoryOption: null,
    // pricingAccessoryCategoryOption: null
    pricingBasePriceTypeOption: null
});
exports.usePricingStore = (0, pinia_1.defineStore)("pricingStore", {
    state: () => getDefaultState(),
    actions: {
        async getPricings(router, query, pricingId) {
            this.loading = true;
            try {
                let url;
                if (pricingId) {
                    url = router.resolve({
                        name: 'customer_pricings_api',
                        query: query,
                        params: { id: pricingId }
                    }).href;
                }
                else {
                    url = router.resolve({
                        name: 'customer_pricings_api',
                        query: query
                    }).href;
                }
                const response = await (0, fetch_1.default)(url);
                let pricings = [];
                if (Array.isArray(response['hydra:member'])) {
                    response['hydra:member'].forEach((element) => {
                        if (element['@type'] === 'CustomerPricing') {
                            pricings.push(element);
                        }
                    });
                }
                this.pricings = pricings;
                this.totalPricings = response['hydra:totalItems'];
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async createPricing(router, request) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'POST' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'create_customer_pricing_api' }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async createPricingFilter(router, request) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'POST' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'create_customer_pricing_filter_api' }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async updatePricing(router, request, pricingId) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'PUT' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'customer_pricings_api', params: { id: pricingId } }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async deletePricing(router, pricingId) {
            this.loading = true;
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'customer_pricings_api', params: { id: pricingId } }).href, { method: 'DELETE' });
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async deletePricingFilter(router, pricingFilterId) {
            this.loading = true;
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'customer_pricing_filters_api', params: { id: pricingFilterId } }).href, { method: 'DELETE' });
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async deletePricingFilters(router, request) {
            this.loading = true;
            const options = { body: JSON.stringify(request), method: 'DELETE' };
            try {
                await (0, fetch_1.default)(router.resolve({ name: 'customer_pricing_filters_delete_api' }).href, options);
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        async checkPricingConflict(router, pricingId) {
            this.loading = true;
            const options = { body: JSON.stringify({ customerPricingId: pricingId }), method: 'POST' };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: 'customer-pricing-conflict-check_api' }).href, options);
                return response;
            }
            catch (error) {
                throw error;
            }
            finally {
                this.loading = false;
            }
        },
        resetAllPricingOptions() {
            this.pricingTypeOption = null;
            this.pricingTyreCategoryOption = null;
            this.pricingPassengerTyreSeasonOption = null;
            this.pricingTruckTyreTypeOption = null;
            this.pricingRimCategoryOption = null;
            this.pricingTubesAndTapesCategoryOption = null;
            // this.pricingAccessoryCategoryOption = null;
        },
        resetPricingOptions() {
            this.pricingPassengerTyreSeasonOption = null;
            this.pricingTruckTyreTypeOption = null;
            this.pricingRimCategoryOption = null;
            this.pricingTubesAndTapesCategoryOption = null;
            // this.pricingAccessoryCategoryOption = null;
        },
        resetState() {
            this.$state = { ...getDefaultState() };
        }
    }
});
